import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext';

export const useFeatureFlag = () => {
  const context = useContext(FeatureFlagContext);

  if (!context) {
    throw new Error('useFeatureFlag must be used within a FeatureFlagProvider');
  }

  return {
    multipleFramingDecisionsEnabled:
      context.flags.multipleFramingDecisionsEnabled,
    toggleMultipleFramingDecisions:
      context.toggles.toggleMultipleFramingDecisions,
  };
};

export default useFeatureFlag;
